
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/library/past-conferences",
      function () {
        return require("private-next-pages/library/past-conferences.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/library/past-conferences"])
      });
    }
  